import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import Article from "@/pages/Article";
import Skuad from "@/pages/Skuad";
import PemainDetail from "@/pages/PemainDetail";
import MatchDetail from "@/pages/MatchDetail";

function App() {
  return (
    <div className="App bg-[#050B14] min-h-screen">
      {/* SVG filter: ubah pixel hitam jadi transparan */}
      <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
        <defs>
          <filter id="black-to-transparent">
            {/* Kalikan luminance ke channel alpha:
                pixel hitam (luma=0) -> alpha=0 (transparan)
                pixel terang -> alpha=1 (opaque) */}
            <feColorMatrix
              type="matrix"
              values="1 0 0 0 0
                      0 1 0 0 0
                      0 0 1 0 0
                      2 2 2 0 -0.1"
            />
          </filter>
        </defs>
      </svg>

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog/:slug" element={<Article />} />
          <Route path="/skuad" element={<Skuad />} />
          <Route path="/pemain/:id" element={<PemainDetail />} />
          <Route path="/laga/:slug" element={<MatchDetail />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
